export default function VisaInfoPanel({ visa }) {
    // Check if visa type is Study Visa
    const isStudyVisa = visa?.visaCategory === "Study Visa"

    return (
      <div className="space-y-4">
        <div className="bg-[#005B96] text-white p-4 rounded-lg">
          <h3 className="font-medium mb-2">Visa Status</h3>
          <input
            type="text"
            value={visa?.visaStatus || "N/A"}
            readOnly
            className="w-full p-2 bg-white text-black rounded border border-white/20"
          />
        </div>
        <div className="bg-[#005B96] text-white p-4 rounded-lg">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm mb-1">Term</label>
            <input
              type="text"
              value={visa?.term || "N/A"}
              readOnly
              className="w-full p-2 bg-white text-black rounded border border-white/20"
            />
          </div>
          <div>
            <label className="block text-sm mb-1">Country</label>
            <input
              type="text"
              value={visa?.countryOfInterest || "N/A"}
              readOnly
              className="w-full p-2 bg-white text-black rounded border border-white/20"
            />
          </div>
        </div>

        </div>
        {/* Show Program and University UI only for Study Visa */}
        {isStudyVisa && (
          <>
            <div className="bg-[#005B96] text-white p-4 rounded-lg">
              <h3 className="font-medium mb-2">Program</h3>
              <input
                type="text"
                value={visa?.program || "N/A"}
                readOnly
                className="w-full p-2 bg-white text-black rounded border border-white/20 mb-2"
              />
              
            </div>

            <div className="bg-[#005B96] text-white p-4 rounded-lg">
              <h3 className="font-medium mb-2">University</h3>
              <input
                type="text"
                value={visa?.institution || "N/A"}
                readOnly
                className="w-full p-2 bg-white text-black rounded border border-white/20"
              />
            </div>
          </>
        )}
  
       {/*   <div className="bg-[#005B96] text-white p-4 rounded-lg">
          <h3 className="font-medium mb-2">Current Residence</h3>
          <input
            type="text"
            readOnly
            className="w-full p-2 bg-white text-black rounded border border-white/20 mb-2"
            />
          <input
            type="text"
            value={visa.email}
            placeholder="Enter full address"
            className="w-full p-2 bg-white text-black rounded border border-white/20 mb-2"
          />
         <input
            type="text"
            placeholder="Enter full address"
            className="w-full p-2 bg-white text-black rounded border border-white/20 mb-2"
          /> 
          <input
            type="text"
            value={visa.mobile}
            readOnly
            className="w-full p-2 bg-white text-black rounded border border-white/20"
          />
        </div>*/}
      </div>
    )
  }
  
  